import { render } from "./Media.vue?vue&type=template&id=5f47fd7e&scoped=true"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=5f47fd7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f47fd7e"

export default script